import { render, staticRenderFns } from "./SlideTitleSettings.vue?vue&type=template&id=7542c17c&scoped=true&"
import script from "./SlideTitleSettings.vue?vue&type=script&lang=js&"
export * from "./SlideTitleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542c17c",
  null
  
)

export default component.exports